import {useTranslation} from "react-i18next";
import CalculatorIcon from "../../../Assets/SVG/CalculatorIcon";
import Space from "Components/Space";
import PageLayout from "Layouts/PageLayout";
import { useNavigate } from "react-router-dom";
import ProjectSettlementSettingsForm from "../../../Features/Settlements/ProjectSettlementSettingsForm";

const New = () => {

    const { t } = useTranslation();

    const navigate = useNavigate();

    return (
        <PageLayout title={`${t('newSettlementSetting')}`} icon={<CalculatorIcon />} includeBox>
            <Space size={"large"} direction={"vertical"}>
                <ProjectSettlementSettingsForm onSubmit={_ => navigate(-1)} />
            </Space>
        </PageLayout>
    )

}

export default New;